import { useRoomContext } from "@livekit/components-react";
import { ConnectionState } from "livekit-client";

export const useLivekitWeakSignalIndicator = () => {
  const room = useRoomContext();

  return room.state === ConnectionState.Reconnecting;
};
